/* eslint-disable quotes */
/* eslint-disable max-lines */
import { Table, Row, Col, Button } from 'reactstrap';
import { useContext, useState, useEffect } from 'react';
import { Context as AuthContext } from '../../../contexts/AuthContext';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Loa from '../../../services/Loa';

type EmployeeSettingsFormProps = {
  isOpen: boolean;
};

const LoaPolices = ({ isOpen }: EmployeeSettingsFormProps) => {
  const { token, currentSchool }: any = useContext(AuthContext);

  const [loaPolices, setLoaPolices] = useState([] as any[]);

  useEffect(() => {
    if (isOpen) {
      listData();
    }
  }, [isOpen]);

  const listData = async () => {
    try {
      const result = await Loa(token).loaPolicyList(currentSchool.value);
      setLoaPolices(result.data || []);
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'No data Found!');
    }
  };

  return (
    <>
      <Row>
        <Col>
          <Button color="primary">
            <Link to={'/loa-policies-settings'} style={{ color: '#FFFFFF' }}>
              <i className="fas fa-plus" />
              <span>Create New</span>
            </Link>
          </Button>
        </Col>
      </Row>
      <Table className="align-items-center table-flush mt-2" responsive>
        <tbody>
          <tr>
            <th>Name</th>
            <th>Time Off Accrual</th>
            <th>Company Payment Amount</th>
            <th>Reasons</th>
            <th>Action</th>
          </tr>
          {loaPolices?.length === 0 && (
            <tr>
              <td colSpan={5} className="text-center">
                Data not found
              </td>
            </tr>
          )}
          {loaPolices.map((s: any) => (
            <tr key={`loaPolices-modal-${s.id}`}>
              <td>{s.name}</td>
              <td>{s.accrual ? 'Continue accruals' : 'Pause accruals'}</td>
              <td>{s.payment_pct}%</td>
              <td>
                {s.loa_reasons && s.loa_reasons.length > 0 ? (
                  <div>
                    {s.loa_reasons.map((reason: string, index: number) => (
                      <span key={index} className="badge badge-primary mr-1">
                        {reason}
                      </span>
                    ))}
                  </div>
                ) : (
                  <span className="text-muted">No reasons</span>
                )}
              </td>
              <td>
                <Link to={`loa-policies-settings/${s?.id}`}>
                  <i className="fas fa-pencil-alt text-mutted mr-3" style={{ cursor: 'pointer' }} />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default LoaPolices;
